import { gql } from "@apollo/client";

export const setLensDescription = gql`
    mutation setLensDescription($lensId: ID!, $description: String!) {
        setLensDescription(input: { lensId: $lensId, description: $description }) {
            lens {
                id
                status
                description
            }
        }
    }
`;
